import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { EVENT_TYPES } from "@/data/content";
import { useContent } from "@/context/ContentContext";
import { mediaUrl } from "@/lib/api";

export default function Services() {
  const { services, content: c } = useContent();
  return (
    <div data-testid="services-page" className="pt-28 md:pt-32">
      <section className="container-lux py-16 md:py-24">
        <div className="max-w-3xl">
          <Reveal>
            <p className="overline mb-6">Our Services</p>
            <h1 className="font-serif-lux text-5xl md:text-7xl font-light leading-[1.02] mb-8">
              {c.services_h1}
            </h1>
            <p className="text-[#4A4A4A] text-lg leading-relaxed">
              {c.services_intro}
            </p>
          </Reveal>
        </div>
      </section>

      <section className="container-lux pb-10">
        {services.map((s, i) => (
          <Reveal key={s.num}>
            <div className={`grid md:grid-cols-2 gap-8 md:gap-16 items-center py-14 md:py-20 border-t border-[#1A1A1A]/10 ${i % 2 === 1 ? "md:[direction:rtl]" : ""}`}>
              <div className="media-zoom aspect-[4/3] [direction:ltr]">
                <img src={mediaUrl(s.image)} alt={s.title} loading="lazy" />
              </div>
              <div className="[direction:ltr]">
                <span className="font-serif-lux text-[#D4AF37] text-5xl md:text-6xl font-light block mb-5">{s.num}</span>
                <h2 className="font-serif-lux text-3xl md:text-4xl font-light leading-tight mb-6">{s.title}</h2>
                <p className="text-[#4A4A4A] text-lg leading-relaxed mb-8">{s.desc}</p>
                <Link
                  to="/quote"
                  data-testid={`service-quote-btn-${s.num}`}
                  className="inline-flex items-center gap-2 btn-outline-dark"
                >
                  Begin Your Journey <ArrowRight size={16} />
                </Link>
              </div>
            </div>
          </Reveal>
        ))}
      </section>

      <section className="bg-[#0A0A0A] text-white py-24 md:py-32">
        <div className="container-lux text-center">
          <Reveal>
            <p className="overline mb-6">Occasions We Cover</p>
            <h2 className="font-serif-lux text-3xl md:text-5xl font-light mb-14 max-w-3xl mx-auto leading-tight">
              {c.services_occasions_heading}
            </h2>
          </Reveal>
          <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-4xl mx-auto">
            {EVENT_TYPES.map((t, i) => (
              <Reveal key={t} delay={i * 0.05}>
                <span className="inline-block border border-white/20 px-6 py-3 text-sm tracking-wide hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors">
                  {t}
                </span>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}>
            <Link to="/quote" data-testid="services-cta-btn" className="btn-gold mt-14">Begin Your Journey</Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
